module.exports = __webpack_public_path__ + "static/media/VPF_LOGO_1.b6d5871a.png";